<template>
  <div class="confirmation-modal">
    <div class="confirmation-modal__checkmark-circle">
      <div class="confirmation-modal__checkmark"></div>
    </div>
    <p class="confirmation-modal__message">{{ message || "Success" }}</p>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props: {
    message: String
  },
  mounted() {
    this.initClosingSequence();
  },
  methods: {
    initClosingSequence() {
      return new Promise(resolve => {
        setTimeout(() => resolve(this.$modal.hide("Confirmation")), 750);
      });
    }
  }
};
</script>

<style lang="scss">
.confirmation-modal {
  box-sizing: border-box;
  height: 300px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  background-color: rgba(18, 137, 9, 0.8);

  &__checkmark-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 4px solid #ffffff;
    border-radius: 50%;
    width: 110px;
    height: 110px;
  }

  &__message {
    margin: 30px 0 0;
    font-size: 36px;
    font-weight: $font_bold;
    color: #ffffff;
  }

  &__checkmark {
    margin-bottom: 10px;
    transform: rotate(45deg);
    height: 35px;
    width: 15px;
    border-bottom: 4px solid #ffffff;
    border-right: 4px solid #ffffff;
  }
}
</style>
